import { SalaryCodeCombobox } from '@/components/combobox/salary-code-combobox'
import { useTranslate } from '@ur-solutions/react-hooks'
import { SettingRow, SettingsSection } from './salary-settings-section'
import type {
  SalarySettingsForm,
  SalarySettingsTabProps,
} from './SalarySettingsFormView'

type ActivitySalaryCodeField = keyof Pick<
  SalarySettingsForm,
  | 'drivingSalaryCode'
  | 'otherWorkSalaryCode'
  | 'availabilitySalaryCode'
  | 'paidPauseSalaryCode'
  | 'dailyRestSalaryCode'
>

export const SalarySettingsSalaryCodes: React.FC<SalarySettingsTabProps> = ({
  form,
}) => {
  const translations = useTranslate({
    salaryCodeForActivityType: 'settings.salary-code-for-activity-type',
    driving: 'common.driving',
    otherWork: 'common.other-work',
    availability: 'common.availability',
    paidPauseSalaryCode: 'settings.paid-pause-salary-code',
    dailyRestSalaryCode: 'settings.daily-rest-salary-code',
    dailyRestSalaryCodeExplanation:
      'settings.daily-rest-salary-code-explanation',
  })
  const { formValues, updateForm } = form

  const rows: {
    field: ActivitySalaryCodeField
    label: string
    description?: string
  }[] = [
    { field: 'drivingSalaryCode', label: translations.driving },
    { field: 'otherWorkSalaryCode', label: translations.otherWork },
    { field: 'availabilitySalaryCode', label: translations.availability },
    { field: 'paidPauseSalaryCode', label: translations.paidPauseSalaryCode },
    {
      field: 'dailyRestSalaryCode',
      label: translations.dailyRestSalaryCode,
      description: translations.dailyRestSalaryCodeExplanation,
    },
  ]

  return (
    <SettingsSection title={translations.salaryCodeForActivityType}>
      {rows.map(({ field, label, description }) => (
        <SettingRow key={field} label={label} description={description}>
          <SalaryCodeCombobox
            mode="single"
            clearable
            value={formValues[field] ?? ''}
            onChange={code => updateForm({ [field]: code || null })}
          />
        </SettingRow>
      ))}
    </SettingsSection>
  )
}
